import { render } from "./ClientTypeList.vue?vue&type=template&id=b13edcae&ts=true"
import script from "./ClientTypeList.vue?vue&type=script&lang=ts"
export * from "./ClientTypeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__